import React, { useState } from 'react';
import { TextField, Button, Link } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import './asset/Login.css'; // 引入自定義的CSS樣式
import ResetPassword from './component/ResetPassword.js'; 
import Typography from '@mui/material/Typography';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://macct.tw/">
        Master Accounting
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Login = () => {
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);

  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await fetch('https://macct.tw/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (responseData.success) {
        // 登入成功的處理
        alert('登入成功!');
        navigate('/'); // 導向Home.js
      } else {
        // 登入失敗的處理
        alert('登入失敗，請重新檢查信箱和密碼');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleForgotPasswordClick = () => {
    setShowResetPasswordForm(true);
  };

  const handleBackToLoginClick = () => {
    setShowResetPasswordForm(false);
  };

  return (
    <div className="login-container">
      {showResetPasswordForm ? (
        <div>
          <ResetPassword />
          <Button onClick={handleBackToLoginClick} >Back</Button>
        </div>
      ) : (
        <div>
        <h2>會員登入</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
            name="username"
            control={control}
            defaultValue=""
            rules={{
                required: 'Username is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Username (Email)"
                  error={!!errors.username}
                  helperText={errors.username?.message}
                />
              )}
            />
            <br /><br />
            <Controller
            name="password"
            control={control}
            defaultValue=""
            rules={{ required: 'Password is required' }}
            render={({ field }) => (
                <TextField
                {...field}
                type="password"
                label="Password"
                error={!!errors.password}
                helperText={errors.password?.message}
                />
            )}
            />
            <br /><br />
            <Button type="submit" variant="contained" color="primary">
            登入
            </Button>
        </form>
        <br />
        <div>
          <Link href="#" onClick={handleForgotPasswordClick}>忘記密碼</Link>
        </div>
        <div style={{ display: 'none' }}>
          <Link href="signup">沒有帳號? 註冊新帳號</Link>
        </div>
        
        <Copyright sx={{ mt: 5 }} />
        </div>
      )}
    </div>
  );
};

export default Login;
